export const LANG_STORAGE = 'lang';
/** @deprecated - Use useUserProfile hook instead */
export const USER_PROFILE_INFO_STORAGE = 'userprofileInfo';
export const COMPLETED_SECTION_STORAGE_KEY = 'crm_performance_report_dismissed_completed';
export const CHOPE_MERCHANT_ID_KEY = 'chopeMerchantID';
export const CHOPE_MERCHANT_ID_EXPIRY_KEY = 'chopeMerchantIDExpiry';

/** Cache duration: 1 day in milliseconds */
export const CHOPE_MERCHANT_ID_CACHE_MS = 24 * 60 * 60 * 1000;

export const GRABX_OVERRIDES_KEY = 'mex_crm_grabx_overrides';
